import { useEffect } from 'react'

type DocumentTitleProps = {
  title: string
}
const useDocumentTitle = ({ title }: DocumentTitleProps) => {
  useEffect(() => {
    window.document.title = title || 'Rockefeller Digital'
  }, [title])
}

export default useDocumentTitle
